import { WEBSOCKET_URL, ADMIN_ROOT_API_URL, USER_ROOT_API_URL } from "../../../../config/settings";

export const LOGIN_USER = "/auth";
export const WEBSOCKET_CONNECTION = WEBSOCKET_URL
export const GET_MAINTENANCE_SETTINGS = ADMIN_ROOT_API_URL + "/get_maintenance_settings";
export const GET_UNSEEN_THREADS = USER_ROOT_API_URL + "/get_unseen_thread";
